// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/apiData';
import model_2 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/cloud';
import model_3 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/common';
import model_4 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/detail';
import model_5 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/favorites';
import model_6 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/feedback';
import model_7 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/img';
import model_8 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/recommend';
import model_9 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/store';
import model_10 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/models/userInfo';
import model_11 from '/opt/jenkins_2.479.3/workspace/prod-material-ui/projects/home-asset/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'apiData', model: model_1 },
model_2: { namespace: 'cloud', model: model_2 },
model_3: { namespace: 'common', model: model_3 },
model_4: { namespace: 'detail', model: model_4 },
model_5: { namespace: 'favorites', model: model_5 },
model_6: { namespace: 'feedback', model: model_6 },
model_7: { namespace: 'img', model: model_7 },
model_8: { namespace: 'recommend', model: model_8 },
model_9: { namespace: 'store', model: model_9 },
model_10: { namespace: 'userInfo', model: model_10 },
model_11: { namespace: '@@initialState', model: model_11 },
} as const
